import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

export var phoneTypeList = [{
  value: 'custom',
  label: 'Custom',
  name: 'SFxCustomPhone'
}, {
  label: 'Mobile Phone',
  value: 'mobile',
  name: 'SFxMobilePhone'
}, {
  label: 'Office Phone',
  value: 'office',
  name: 'SFxOfficePhone'
}, {
  label: 'Business Phone',
  value: 'business',
  name: 'SFxBusinessPhone'
}, {
  label: 'Home Phone',
  value: 'home',
  name: 'SFxHomePhone'
}, {
  label: 'Fax',
  value: 'fax',
  name: 'SFxFaxPhone'
}];
export var initDataFormatFactory = function initDataFormatFactory(data, staticSource) {
  var _data$userAddresses = data.userAddresses,
      userAddresses = _data$userAddresses === void 0 ? [] : _data$userAddresses,
      _data$userPhones = data.userPhones,
      userPhones = _data$userPhones === void 0 ? [] : _data$userPhones,
      organization = data.organization,
      mobilePhone = data.mobilePhone,
      avatar = data.avatar,
      userId = data.id;
  var userAddressesList = userAddresses.map(function (_ref) {
    var address = _ref.address;
    return _objectSpread(_objectSpread({}, address), {}, {
      _id: address.id,
      province: {
        geonameId: address.stateOrProvinceGeoNameId || '',
        name: address.stateOrProvince || ''
      },
      country: {
        geonameId: address.countryGeoNameId,
        countryName: address.country
      }
    });
  });

  if (organization) {
    var primaryAddress = organization.primaryAddress;

    var workAddress = _objectSpread(_objectSpread({}, primaryAddress), {}, {
      _id: primaryAddress.id,
      province: {
        geonameId: primaryAddress.stateOrProvinceGeoNameId,
        name: primaryAddress.stateOrProvince
      },
      country: {
        countryName: primaryAddress.country,
        geonameId: primaryAddress.countryGeoNameId
      },
      main: true
    });

    if (userAddressesList.filter(function (i) {
      return i.id === workAddress.id;
    }).length) {
      userAddressesList = userAddressesList.filter(function (i) {
        return i.id !== workAddress.id;
      });
      userAddressesList.unshift(workAddress);
    }
  }

  var userPhonesList = userPhones.map(function (_ref2) {
    var type = _ref2.type,
        phone = _ref2.phone;
    return _objectSpread(_objectSpread({}, phone), {}, {
      _id: phone.id,
      phoneType: phoneTypeList.find(function (j) {
        return j.value === type;
      }) || {
        label: '',
        value: ''
      },
      countryCode: {
        GeonameId: phone.countryCodeGeoNameId,
        Code: phone.countryCode
      },
      customName: phone.name
    });
  });

  if (mobilePhone) {
    var _ref3 = mobilePhone.userPhones || [],
        _ref4 = _slicedToArray(_ref3, 1),
        workMobilePhoneType = _ref4[0];

    var workMobilePhone = _objectSpread(_objectSpread({}, mobilePhone), {}, {
      _id: mobilePhone.id,
      phoneType: phoneTypeList.find(function (j) {
        return j.value === workMobilePhoneType.type;
      }) || {
        label: '',
        value: ''
      },
      countryCode: {
        GeonameId: mobilePhone.countryCodeGeoNameId,
        Code: mobilePhone.countryCode
      },
      main: true
    });

    if (userPhonesList.filter(function (i) {
      return i.id === workMobilePhone.id;
    }).length) {
      userPhonesList = userPhonesList.filter(function (i) {
        return i.id !== workMobilePhone.id;
      });
      userPhonesList.unshift(workMobilePhone);
    }
  }

  var userData = {
    userId: userId,
    currentAvatar: avatar && avatar.url,
    profile: {
      firstName: data.givenName,
      lastName: data.surname,
      email: data.email,
      country: {
        geonameId: data.countryGeoNameId || '',
        countryName: data.country || ''
      },
      region: data.region || '',
      language: staticSource['supportedLanguages'] && staticSource['supportedLanguages'].find(function (j) {
        return j.value === data.language;
      }) || {
        label: '',
        value: ''
      },
      timeZone: {
        Alpha2Code: data.timeZoneAlpha2Code,
        Alpha3Code: data.timeZoneAlpha3Code,
        DstOffset: data.timeZone
      },
      userPhones: userPhonesList,
      userAddresses: userAddressesList
    }
  };
  return userData;
};
export var saveDataFormatFactory = function saveDataFormatFactory(data) {
  var userAddresses = data.userAddresses.map(function (i) {
    return {
      city: i.city,
      country: i.country.countryName,
      region: i.country.continent || i.region,
      countryGeoNameId: i.country.geonameId,
      stateOrProvince: i.province && i.province.name,
      stateOrProvinceGeoNameId: i.province && i.province.geonameId,
      zipOrPostcode: i.zipOrPostcode,
      line2: i.line2,
      line1: i.line1,
      name: i.name,
      id: i.id
    };
  });
  var userPhones = data.userPhones.map(function (i) {
    return {
      id: i.id,
      number: i.number,
      extension: i.extension,
      customName: i.customName,
      countryCode: i.countryCode.Code,
      countryCodeGeoNameId: i.countryCode.GeonameId,
      type: i.phoneType.value
    };
  });
  var saveData = {
    country: data.country.countryName,
    countryGeoNameId: data.country.geonameId,
    region: data.region,
    language: data.language,
    timeZone: data.timeZone || {
      Alpha2Code: '',
      Alpha3Code: '',
      DstOffset: ''
    },
    surname: data.lastName,
    givenName: data.firstName,
    userAddresses: userAddresses,
    userPhones: userPhones
  };
  return saveData;
};